import { useEffect, useState } from "react";
import { CheckIcon, Cross1Icon } from "@radix-ui/react-icons";
import { Card } from "../../../Components/ui/card";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "@/src/State/store";
import axios from "axios";
import CircularProgress from "@mui/material/CircularProgress/CircularProgress";

const AdminChannelList = () => {
  const [selectedChannel, setSelectedChannel] = useState<string | null>(null);
  const [channels, setChannels] = useState<
    { channel_id: number; channel_name: string; channel_description: string }[]
  >([]);
  const apiUrlAdvAcc = useSelector((state: RootState) => state.authentication.apiURL);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const navigate = useNavigate();

  const GetChannelList = async () => {
    try {
      const response = await axios.get(`${apiUrlAdvAcc}/GetChannelList`);
      if (response.data.status === "Success" && Array.isArray(response.data.channelList)) {
        setChannels(response.data.channelList);
      } else {
        setChannels([]);
      }
    } catch {
      setChannels([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    GetChannelList();
  }, []);

  return (
    <>
      {isLoading ? (
        <div className="flex flex-col items-center justify-center h-[500px]">
          <CircularProgress color="primary" />
        </div>
      ) : (
        <div className="flex flex-wrap gap-4 p-2 w-full">
          {[...channels]
            .sort((a, b) => {
              const priority = ["WhatsApp", "SMS"];
              const aPriority = priority.includes(a.channel_name) ? priority.indexOf(a.channel_name) : Infinity;
              const bPriority = priority.includes(b.channel_name) ? priority.indexOf(b.channel_name) : Infinity;
              return aPriority - bPriority;
            })
            .map((ch) => (
              <Card
                key={ch.channel_id}
                className={`w-[250px] p-[30px] relative cursor-pointer border border-gray-300`}
                onClick={() => {
                  const name = ch.channel_name.toLowerCase();
                  // Pass channelId dynamically to detail pages
                  if (name.includes("sms")) {
                    navigate("/adminNavbar/sms", { state: { selectedLabel: "Channels", channelId: ch.channel_id } });
                  } else if (name.includes("whatsapp")) {
                    navigate("/adminNavbar/whatsapp", { state: { selectedLabel: "Channels", channelId: ch.channel_id } });
                  }
                }}
              >
                <div className="flex w-full">
                  <div>
                    <h3 className="font-semibold font-[14px] text-[#020617] text-left flex w-full mb-2">
                      {ch.channel_name}
                    </h3>
                  </div>
                  <div className="flex w-full justify-end absolute right-7 mt-1">
                    {selectedChannel?.toLowerCase() === ch.channel_name.toLowerCase() ? (
                      <CheckIcon className="text-[#3A85F7] w-4 h-4 rounded-full border border-blue-500" />
                    ) : (
                      <Cross1Icon className="text-[#E2E8F0] w-4 h-4 rounded-full border border-gray-200" />
                    )}
                  </div>
                </div>
                <p className="mt-2 text-[#64748B] font-normal text-[12px] h-[68px] text-left w-full">
                  {ch.channel_description}
                </p>
              </Card>
            ))}
        </div>
      )}
    </>
  );
};

export default AdminChannelList;
